import { TDefaultTheme } from '@lib/theme/defaultTheme';
import styled from 'styled-components';

export const PageHeaderWrapperSC = styled.div<{
  variant: keyof TDefaultTheme['color']['surface'];
}>`
  min-height: calc(100vh - 60px);
  background-color: ${({ theme, variant }) => theme.color.surface[variant]};

  .page-header {
    padding-left: 48px;
    padding-right: ${({ theme }) => theme.spacings.component.XL}px;
    background-color: ${({ theme }) => theme.color.surface.baseline};

    .header-breadcrumbs {
      min-width: 1px;
      height: 36px;
    }
  }

  &.sticky-header .page-header {
    position: sticky;
    top: 60px;
    z-index: 1;
  }

  .page-children {
    padding: ${({ theme }) => theme.spacings.component.L}px
      ${({ theme }) => theme.spacings.component.XL}px;
  }
`;
